import { Switch, Route, Redirect } from 'react-router';
import { ERoutes } from '../../util/constants';
import MigrateAccountContext, {
    MigrateAccountProvider,
    EMigrateAccountUiState,
} from '../../contexts/MigrateAccountContext';
import MigrateAccountForm from '../../components/MigrateAccountForm/MigrateAccountForm';
import MigrateAccountSuccess from '../../components/MigrateAccountSuccess/MigrateAccountSuccess';
import { FC, useContext } from 'react';
import { Alert, Stack } from '@mui/material';
import GlobalContext from '../../contexts/GlobalContext';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { Loader } from '../../components/Loader/Loader';
import MigrateAccountVerify from '../../components/MigrateAccountVerify/MigrateAccountVerify';

const MigrateAccountRouter: FC = () => {
    return (
        <Switch>
            <Route exact path={ERoutes.migrateAccount}>
                <MigrateAccountForm />
            </Route>
            <Route exact path={ERoutes.migrateAccountVerify}>
                <MigrateAccountVerify />
            </Route>
            <Route exact path={ERoutes.migrateAccountSuccess}>
                <MigrateAccountSuccess />
            </Route>
        </Switch>
    );
};

const MigrateAccountUi: FC = () => {
    const { language } = useContext(GlobalContext);
    const { migrateAccountUiState } = useContext(MigrateAccountContext);
    switch (migrateAccountUiState) {
        case EMigrateAccountUiState.default:
        case EMigrateAccountUiState.routerParsed:
            return (
                <PageLayoutV2 showFooter={false}>
                    <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                        <Loader />
                    </Stack>
                </PageLayoutV2>
            );

        case EMigrateAccountUiState.loading:
        case EMigrateAccountUiState.ready:
        case EMigrateAccountUiState.error:
            return <MigrateAccountRouter />;
        case EMigrateAccountUiState.success:
            return (
                <>
                    <Redirect to={ERoutes.migrateAccountVerify} />
                    <MigrateAccountRouter />
                </>
            );
        case EMigrateAccountUiState.notInitialized:
            return <Redirect to={ERoutes.login} />;
        default:
            return (
                <>
                    {console.error(`Migrate account ui state set incorrectly -- ${migrateAccountUiState}`)}
                    <Alert severity="error">{language.error.generic}</Alert>
                </>
            );
    }
};

const MigrateAccountScreen: FC = () => {
    return (
        <MigrateAccountProvider>
            <MigrateAccountUi />
        </MigrateAccountProvider>
    );
};

export default MigrateAccountScreen;
